import { Caption, HelpIcon } from 'canoe';
import React from 'react';
import styled from 'styled-components';

import { useViewportBreakpoint } from 'craft/state';
import { MediaBreakpoint } from 'craft/types';

const Content = styled.div`
  padding: ${({ theme }) => `0 ${theme.spaces.s}`};
`;

const viewportSizes = {
  [MediaBreakpoint.SM]: '699px',
  [MediaBreakpoint.MD]: '1199px',
} as Record<MediaBreakpoint, string>;

export const ResponsiveCssControlsDescription = () => {
  const viewportBreakpoint = useViewportBreakpoint();
  const breakpointText = viewportSizes[viewportBreakpoint] || '';

  return (
    <Content css={{ display: 'flex' }}>
      <HelpIcon color="OnyxGrayL30" size="s" />
      <Caption color="OnyxGrayL30" css={{ paddingLeft: '8px', marginBottom: 0 }}>
        The styles below will only apply to screen sizes smaller than {breakpointText} wide.
      </Caption>
    </Content>
  );
};
